const Vue = require('vue/dist/vue.esm-bundler');
import { defineComponent } from "vue";
import { Panzoom } from "@fancyapps/ui";
import toggle from 'npm-kit-toggle';
import ripple from 'npm-kit-ripple';

import Swiper, { Mousewheel, Scrollbar } from 'swiper';

import getSupportedEvents from "./js/functions/getSupportedEvents";
import MapMarkers from "./components/MapMarkers.vue";
import MapDialog from "./components/MapDialog.vue";
import MapRoutes from "./components/MapRoutes.vue";

import { items } from './itemsData';

import 'swiper/css';
import 'swiper/css/scrollbar';
import './scss/index.scss';

Swiper.use([Mousewheel, Scrollbar]);
Swiper.defaults.touchStartPreventDefault = false
window.Swiper = Swiper

const $root = document.getElementById('root')


let mapPanzoom;
const baseScale = 1;
const minScale = baseScale;
const maxScale = 2;
const step = 1;


ripple.init()
toggle.init()

ripple.attach('.btn')
ripple.attach('.waved')
ripple.deAttach('.btn--link')
const globalObject = window
const appComponent = defineComponent({
	data() {
		return {
			currentItem: undefined,
			startedTimeout: undefined,
			items,

		}
	},
	methods: {


	},
	provide() {
		return {
			window: globalObject,
			items: this.items
		}
	}
})

const app = Vue.createApp(appComponent)
app.component('map-markers', MapMarkers)
app.component('map-dialog', MapDialog)
app.component('map-routes', MapRoutes)
app.mount(document.getElementById('map'))




let panInited = false
if (window.screen.width > 580) {
	initMapPanzoom()

}

window.addEventListener('resize', () => {
	if (window.screen.width <= 580) {
		mapPanzoom.destroy()
		panInited = false
	} else if (!panInited) {
		initMapPanzoom()
	}
})

function initMapPanzoom() {
	const $zoomInBtn = document.querySelector('.map-zoom-in')
	const $zoomOutBtn = document.querySelector('.map-zoom-out')
	const $cover = document.querySelector("#map-panzoom")
	if (!$cover) {
		return
	}
	panInited = true

	mapPanzoom = new Panzoom($cover, {
		panOnlyZoomed: true,
		baseScale,
		minScale,
		maxScale,
		step,
		pinchToZoom: true,
		friction: 1,
		bounceForce: 0.25,

		wheel: () => false,
		// click: () => false,
	});

	$cover.addEventListener(getSupportedEvents().end, () => {
		checkPanzoom()
		setTimeout(checkPanzoom, 100)
	})

	$zoomInBtn.addEventListener('click', (event) => {
		event.stopPropagation();
		mapPanzoom.zoomIn();
		checkPanzoom()

	})

	$zoomOutBtn.addEventListener('click', (event) => {
		event.stopPropagation();
		mapPanzoom.zoomTo(baseScale);
		checkPanzoom()

	})

	function checkPanzoom() {
		// 
		if (mapPanzoom.transform.scale == maxScale) {
			$cover.classList.add('max-scale')
		} else {
			$cover.classList.remove('max-scale')

		}
	}
	mapPanzoom.updateMetrics()
	mapPanzoom.zoomTo(baseScale)
}

// new Swiper(".root", {
// 	watchSlidesProgress: true,
// 	direction: 'vertical',
// 	slidesPerView: 'auto',
// 	mousewheel: true,
// 	touchRatio: getSupportedEvents().type == 'touch' ? 1 : 0,
// 	speed: 750,
// 	initialSlide: 3,
// 	scrollbar: {
// 		el: ".swiper-scrollbar",
// 		hide: true,
// 	},
// });